<template>
  <popover-right v-model="isShowFollow" width="900px" :closed="cancel" class="customer-follow-detail-dialog">
    <p class="toggle-btn" v-if="allowToggle">
      <i class="iconfont iconarrowleft toggle-btn-item" :class="isFirstPage() ? 'disabled' : ''" @click="toggleFollow('prev')"></i>
      <i class="iconfont iconarrowright toggle-btn-item" :class="isLastPage() ? 'disabled' : ''" @click="toggleFollow('next')"></i>
    </p>
    <h1 class="popover-right-title">「{{info.admin_name}}」跟进客户{{info.type == 2 ? '商机' : info.type == 3 ? '订单' : ''}}</h1>
    <div class="customer-follow-detail">
      <div class="follow-tab">
        <h1 class="tab-title">跟进方式</h1>
        <div class="tab-item">
          <span class="tab-label">客户：</span>
          <p class="tab-content tab-cursor" @click="handleCustomerDetail">{{info.customer_name}}{{info.contact_tel ? `（${info.contact_tel}）` : ''}}</p>
        </div>
        <div class="tab-item">
          <span class="tab-label">跟进类型：</span>
          <p class="tab-content">{{info.type_name}}-{{info.way_name}}{{info.way == 2 ? `（${info.sub_way_name}）` : ''}}</p>
        </div>
        <div class="tab-item" v-if="info.type == 2 || info.type == 3">
          <span class="tab-label">{{info.type == 2 ? '商机' : '订单'}}：</span>
          <p class="tab-content tab-cursor" @click="handleApproveDetail">{{info.project_name || '--'}}</p>
        </div>
        <div class="tab-item">
          <span class="tab-label">跟进时间：</span>
          <p v-analysis-time:all="info.follow_up_time" class="tab-content"></p>
        </div>
      </div>
      <div class="follow-tab">
        <h1 class="tab-title">跟进内容</h1>
        <div class="panel-con" v-if="info.labels && info.labels.length > 0">
          <span v-for="(value, key) in info.labels" :key="key" class="panel active">{{value}}</span>
        </div>
        <div class="tab-item" v-if="info.level">
          <span class="tab-label">{{info.is_first_update == 0 ? '客户等级更新成:' : '客户等级重新评估为：'}}</span>
          <p class="tab-content">{{info.level}}</p>
        </div>
        <div class="tab-item" v-if="info.content">
          <span class="tab-label">跟进内容如下：</span>
          <p class="tab-content">{{info.content}}</p>
        </div>
        <div class="tab-item" v-if="info.next_follow_up_time && info.next_follow_up_time > 0">
          <span class="tab-label">下次跟进时间：</span>
          <p  class="tab-content">{{parseTime(info.next_follow_up_time ) }}</p>
        </div>
        <div class="tab-item" v-if="info.alert_time && info.alert_time > 0">
          <span class="tab-label">下次跟进提醒时间：</span>
          <p  class="tab-content">{{ parseTime(info.alert_time )}}</p>
        </div>
        <div v-if="info.common_update && info.common_update.length > 0" class="update-groups">
          <p class="update-table-title">{{info.is_first_update == 0 ? '基本资料更新:' : '基本资料重新评估为：'}}</p>
          <div class="update-table-list">
            <div v-for="(item, key) in info.common_update" :key="key" class="update-table-item">
              <p class="table-header">{{item.name}}</p>
              <p class="table-body">{{item.val}}</p>
            </div>
          </div>
        </div>
        <div v-if="info.thread_update && info.thread_update.length > 0" class="update-groups">
          <p class="update-table-title">{{info.is_first_update == 0 ? '购房意向更新:' : '购房意向重新评估为：'}}</p>
          <div class="update-table-list">
            <div v-for="(item, key) in info.thread_update" :key="key" class="update-table-item">
              <p class="table-header">{{item.name}}</p>
              <p class="table-body">{{item.val}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {getFollowDetailById} from '@/api/custome';
import {followLogList} from '@/api/workflow';
import { parseTime} from '@/utils/index';
export default{
  name: 'CustomerFollowDetail',
  components: {PopoverRight},
  props: {
    value: String,
    follow_id: [Number, String],
    emitName: {
      type: String,
      default: ''
    },
    dataCondition: Object,
    allowToggle: {
      type: Boolean,
      default: false
    },
    dataIndex: Number
  },
  data () {
    return {
      info: {},
      index: this.dataIndex,
      condition: {...this.dataCondition || {}},
      id: this.follow_id,
      parseTime
    }
  },
  computed: {
    isShowFollow () {
      return this.value === 'customerFollowDetail';
    }
  },
  created() {
    this.initDetail();
    if (this.allowToggle) {
      this.getToggleList();
    }
  },
  methods: {
    async initDetail () {
      try {
        const res = await getFollowDetailById(this.id);
        this.info = res;
      } catch (error) {
        this.$message.error(error.msg || '查询客户意向出现错误');
      }
    },
    async getToggleList () {
      try {
        const res = await followLogList(this.condition);
        this.per_to = res.to;
        this.per_total = res.total;
        this.toggleList = res.data || [];
      } catch (error) {
        this.toggleList = [];
      }
    },
    cancel () {
      this.info = {};
      this.$emit('input', '');
    },
    // 跳转到客户详情
    handleCustomerDetail () {
      this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
        customerId: this.info.customer_id
      }});
    },
    // 跳转到商机/订单详情
    handleApproveDetail () {
      if (this.info.type == 2) {
        this.$EventBus.$emit(this.emitName, {category: 'bussinessDetail', params: {
          bussinessId: this.info.business_id
        }});
      } else {
        this.$EventBus.$emit(this.emitName, {category: 'orderDetail', params: {
          orderId: this.info.order_id,
          bussinessId: this.info.business_id
        }});
      }
    },
    isLastPage () {
      if (!this.allowToggle) return true;
      const switchList = this.toggleList?.length ?? 0;
      return this.per_to === this.per_total && this.index === switchList - 1;
    },
    isFirstPage () {
      if (!this.allowToggle) return true;
      return this.condition.page === 1 && this.index === 0;
    },
    async toggleFollow (type) {
      if (type === 'prev' && this.isFirstPage()) return null;
      if (type === 'next' && this.isLastPage()) return null;
      this.loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await this.handleSwitch(type);
      this.loading.close();
      this.loading = null;
    },
    async handleSwitch (type) {
      const isNext = type === 'next';
      const index = isNext ? this.index + 1: this.index - 1;
      const next = this.toggleList[index];
      if (next) {
        this.id = next.id;
        this.index = isNext ? this.index + 1 : this.index - 1;
        await this.initDetail();
      } else {
        this.condition.page = isNext ? this.condition.page + 1 : this.condition.page - 1;
        await this.getToggleList();
        this.index = isNext ? -1 : this.toggleList.length;
        await this.handleSwitch(type);
      }
    },
  },
}
</script>
<style lang="less" scoped>
.customer-follow-detail{
  padding: 10px;
  .follow-tab{
    border-bottom: 1px solid #E8E8E8;
    padding: 20px 20px;
    &:last-child{
      border-bottom: 0;
    }
    .tab-title{
      color: #000;
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 10px;
    }
    .tab-item{
      padding-left: 20px;
      line-height: 20px;
      padding: 7px 0;
      .box(start, start);
    }
    .tab-label{
      font-size: 13px;
      color: #333;
      display: inline-block;
    }
    .tab-content{
      font-size: 13px;
      color: #333;
      display: inline-block;
    }
    .tab-cursor{
      cursor: pointer;
      color: #3168FF;
    }
  }
  .panel-con{
    display: flex;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    padding: 7px 0;
    .panel{
      min-width: 60px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      background: #F1F1F2;
      border-radius: 3px;
      color: #666;
      font-size: 12px;
      display: block;
      text-align: center;
      margin: 0 10px 0px 0;
      cursor: pointer;
    }
    .panel.active{
      background: #3F80FE;
      color: #fff;
    }
  }
  .update-table-list{
    margin-top: 12px;
    border: 1px solid #E8E8E8;
    .update-table-item{
      width: 100%;
      display: -webkit-box;
      border-bottom: 1px solid #E8E8E8;
      &:last-child{
        border-bottom: 0;
      }
    }
    .table-header{
      background: #EEF5FF;
      color: #333333;
      font-size: 12px;
      font-weight: bold;
      width: 150px;
      text-align: center;
      padding: 10px 0;
      line-height: 20px;
    }
    .table-body{
      background: #fff;
      color: #333333;
      font-size: 12px;
      padding: 10px 15px;
      line-height: 20px;
      border-left: 1px solid #E8E8E8;
      .boxFlexAll();
    }
  }
  .update-table-title{
    color: #333333;
    font-size: 14px;
    margin-top: 10px;
  }
  .update-groups{
    padding-bottom: 20px;
    width: 700px;
  }
}
</style>
<style lang="less">
.customer-follow-detail-dialog .popover-dialog.el-dialog .modify-container{
  overflow: visible;
}
</style>